export default __webpack_public_path__ + "static/media/Figure 8 setup.ebf881b7.jpg";